import axios from 'axios';
import store from '@/store';
import router from '@/router';
import i18n from '@/plugins/i18n';

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Check if this is a 401 error
      if (error.response?.status === 401) {
        // Check if we're on a driver route - let driver store handle it
        const currentRoute = router.currentRoute; // Vue 2 syntax
        if (currentRoute.meta?.isDriverRoute || currentRoute.path?.startsWith('/driver')) {
          // Don't intercept driver route errors - let the driver store handle them
          return Promise.reject(error);
        }
        
        // Handle regular app authentication errors
        if (currentRoute.meta?.requiresAuth || currentRoute.meta?.requiresAdminAuth) {
          store.dispatch('auth/LOGOUT');
          router.push('/login').catch(() => {});
          return Promise.reject(new Error(i18n.t('authentication.session_expired')));
        }
      }
      
      return Promise.reject(error);
    }
  );
}
